import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { AppService } from "src/_services/app.service";

@Component({
  selector: "app-test-cases-result",
  templateUrl: "./test-cases-result.component.html",
  styleUrls: ["./test-cases-result.component.scss"],
})
export class TestCasesResultComponent implements OnInit {
  testCases;
  operatorId: string = "";
  userId: string = "";
  userToken: string = "";
  testCasesResult;
  providerId: string = "";

  datalistDisplayedColumns: string[] = [
    "S.NO",
    "Result",
    "Test Name",
    "Test Cases",
  ];

  testCaseTableData: string[] = [
    "S.No",
    "Test Name",
    "Request Body",
    "Response Body",
    "Delta",
    "Result",
  ];

  constructor(
    private router: Router,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private appService: AppService
  ) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      console.log("---->", params);
      this.operatorId = params["operatorId"];
      this.userId = params["userId"];
      this.userToken = params["userToken"];
      this.providerId = params["providerId"];
      this.testCases = { testCaseNames: params["testCases"] };
    });
    this.getTestCasesResult();
  }

  stringify(data) {
    return JSON.stringify(data, null, "\t");
  }

  getTestCasesResult() {
    try {
      this.appService
        .getTestCasesResult(
          this.operatorId,
          this.providerId,
          this.userId,
          this.userToken,
          this.testCases
        )
        .subscribe((res) => {
          console.log(res);
          if (res.status === "RS_OK") {
            this.testCasesResult = res;
          } else {
            this.appService.openErrorBar(res.errorDescription);
            this.goBackToTestCases()
          }
        });
    } catch (err) {}
  }

  goBackToTestCases() {
    this.location.back();
  }

  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getExportExcel() {
      const contentType = "application/vnd.ms-excel";
      let blob1 = this.b64toBlob(this.testCasesResult.file, contentType);
      let blobUrl1 = URL.createObjectURL(blob1);
      const link = document.createElement("a");
      link.href = blobUrl1;
      link.setAttribute("download", `testCaseResults.xlsx`);
      document.body.appendChild(link);
      link.click();
    };
  }

